import { Fragment, type ReactNode } from 'react';

export interface KeyValueItem {
  label: ReactNode;
  value: ReactNode;
  hidden?: boolean;
}

/** Definition-list grid: stacks on phones, two columns from `sm`. */
export function KeyValue({ items, className = '' }: { items: KeyValueItem[]; className?: string }) {
  return (
    <dl className={`grid grid-cols-1 gap-x-6 gap-y-0.5 sm:grid-cols-[minmax(8rem,max-content)_minmax(0,1fr)] sm:gap-y-2.5 ${className}`}>
      {items
        .filter((i) => !i.hidden)
        .map((i, idx) => (
          <Fragment key={idx}>
            <dt className="text-sm text-base-content/55 max-sm:mt-2.5 max-sm:first:mt-0">{i.label}</dt>
            <dd className="break-anywhere text-sm">{i.value === null || i.value === undefined || i.value === '' ? <span className="text-base-content/40">—</span> : i.value}</dd>
          </Fragment>
        ))}
    </dl>
  );
}
